module.exports = __webpack_public_path__ + "static/img/newLogo.c7cf4258.png";